/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import Immutable from 'immutable';

import PlanetModel from 'astro/server/planet';

import InteractionsToState from 'astro/fake/state/interactions.to';
import InteractionsFromState from 'astro/fake/state/interactions.from';

import ProjectilesToState from 'astro/fake/state/projectiles.to';
import ProjectilesFromState from 'astro/fake/state/projectiles.from';

import EntitiesState from 'astro/fake/state/entities';
import SectorsState from 'astro/fake/state/sectors';
import ZonesState from 'astro/fake/state/zones';
import UsersState from 'astro/fake/state/users/local';

import ConstantsState from 'astro/fake/state/constants';


export default (planet) =>
{
  let state = new Immutable.Map();

  state = state.set('currentPlanet', planet.getCurrentPlanet());

  state = state.set('interactionsTo', InteractionsToState(planet));
  state = state.set('interactionsFrom', InteractionsFromState(planet));

  state = state.set('projectilesTo', ProjectilesToState(planet));
  state = state.set('projectilesFrom', ProjectilesFromState(planet));

  state = state.set('entities', EntitiesState(planet));
  state = state.set('sectors', SectorsState(planet));
  state = state.set('zones', ZonesState(planet));
  state = state.set('users', UsersState(planet));

  state = state.set('constants', ConstantsState(planet.getConstants()));

  return new PlanetModel(state, null);
}
